/**
 * Language configuration for the LanguageSwitcher component
 *
 * To add a new language:
 * 1. Add the language object to SUPPORTED_LANGUAGES array
 * 2. Update i18n/index.js with translation imports and resources
 * 3. Update supportedLngs in i18n config
 */

export const SUPPORTED_LANGUAGES = [
  { code: 'de', flag: '\u{1F1E9}\u{1F1EA}', nativeName: 'Deutsch', englishName: 'German' },
  { code: 'en', flag: '\u{1F1EC}\u{1F1E7}', nativeName: 'English', englishName: 'English' },
  { code: 'el', flag: '\u{1F1EC}\u{1F1F7}', nativeName: 'Ελληνικά', englishName: 'Greek' },
  { code: 'it', flag: '\u{1F1EE}\u{1F1F9}', nativeName: 'Italiano', englishName: 'Italian' },
  { code: 'pt', flag: '\u{1F1F5}\u{1F1F9}', nativeName: 'Português', englishName: 'Portuguese' },
  // Add more languages here as they become available:
  // { code: 'fr', flag: '\u{1F1EB}\u{1F1F7}', nativeName: 'Français', englishName: 'French' },
  // { code: 'es', flag: '\u{1F1EA}\u{1F1F8}', nativeName: 'Español', englishName: 'Spanish' },
  // { code: 'nl', flag: '\u{1F1F3}\u{1F1F1}', nativeName: 'Nederlands', englishName: 'Dutch' },
  // { code: 'pl', flag: '\u{1F1F5}\u{1F1F1}', nativeName: 'Polski', englishName: 'Polish' },
  // { code: 'sv', flag: '\u{1F1F8}\u{1F1EA}', nativeName: 'Svenska', englishName: 'Swedish' },
  // { code: 'da', flag: '\u{1F1E9}\u{1F1F0}', nativeName: 'Dansk', englishName: 'Danish' },
];

/**
 * Get language data by code
 * @param {string} code - Language code (e.g., 'de', 'en')
 * @returns {Object} Language object or first language as fallback
 */
export function getLanguageByCode(code) {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code) || SUPPORTED_LANGUAGES[0];
}

/**
 * Get flag emoji for a language code
 * @param {string} code - Language code
 * @returns {string} Flag emoji
 */
export function getLanguageFlag(code) {
  return getLanguageByCode(code).flag;
}

/**
 * Get native name for a language code
 * @param {string} code - Language code
 * @returns {string} Native language name
 */
export function getLanguageNativeName(code) {
  return getLanguageByCode(code).nativeName;
}

/**
 * Get English name for a language code
 * @param {string} code - Language code
 * @returns {string} English language name
 */
export function getLanguageEnglishName(code) {
  return getLanguageByCode(code).englishName;
}
